import {
  TServerErrorResponse,
  TranscriptSegment,
  MergeSpeakersRequest,
} from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const CONVERSATION_SEGMENT_GET = "conversation-segment-get";

export const getConversationSegment = async (conversationId?: string) => {
  if (!conversationId) return;
  try {
    const response = await http.get<TranscriptSegment[]>(
      links.conversationSegment.byConversationId(conversationId),
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateConversationSegment = async (
  conversationId: string,
  segmentId: string,
  data: Partial<TranscriptSegment>,
) => {
  if (!conversationId || !segmentId) {
    throw new Error("Conversation ID and Segment ID are required");
  }
  try {
    const response = await http.patch<TranscriptSegment>(
      links.conversationSegment.byId(conversationId, segmentId),
      data,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const mergeSpeakers = async (
  conversationId: string,
  data: MergeSpeakersRequest,
) => {
  try {
    const response = await http.post(
      links.conversationSegment.mergeSpeakers(conversationId),
      data,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
